export const DATA_VIZ_ROLE_COLORS = {
  "provider-whatsapp": "var(--data-viz-provider-whatsapp, #10b981)",
  "provider-ordering": "var(--data-viz-provider-ordering, #3b82f6)",
  "provider-phone": "var(--data-viz-provider-phone, #8b5cf6)",
  "provider-sms": "var(--data-viz-provider-sms, #f59e0b)",
  "provider-web-chat": "var(--data-viz-provider-web-chat, #3b82f6)",
  "provider-default": "var(--data-viz-provider-default, #6b7280)",
} as const;

export type DataVizRole = keyof typeof DATA_VIZ_ROLE_COLORS;

const PROVIDER_ROLES: Record<string, DataVizRole> = {
  whatsapp: "provider-whatsapp",
  ordering: "provider-ordering",
  phone: "provider-phone",
  sms: "provider-sms",
  web_chat: "provider-web-chat",
};

export function resolveProviderDataVizRole(provider?: string | null): {
  color: string;
  role: DataVizRole;
} {
  const role = PROVIDER_ROLES[provider || ""] || "provider-default";
  return { color: DATA_VIZ_ROLE_COLORS[role], role };
}
